const defaultData = {
  name: "",
  price: "",
  discount: "",
  points: "",
  description: [],
  type: "",
  category: "",
  pieces: "",
  edit: false,
  reservation: false,
  sold: 0,
  idx: null,
  data: null,
};

export const productDetailReducer = (productDetail = defaultData, action) => {
  const { type, payload } = action;
  switch (type) {
    case "OPEN_EDIT_PRODUCT_MODAL":
      const { open, data: formData, idx } = payload;
      const {
        _id,
        name,
        price,
        discount,
        points,
        description,
        type,
        category,
        reservation,
        sold,
        pieces,
      } = formData;

      return {
        ...productDetail,
        product_modal: open,
        edit: true,
        _id,
        name,
        price,
        discount,
        points,
        description,
        type,
        category,
        pieces,
        reservation,
        sold,
        idx: idx,
      };
    case "PRODUCT_DETAIL":
      return {
        ...productDetail,
        data: payload,
      };
    // case "CHANGE_TOTAL_PIECES":
    //   productDetail.data.pieces -= 1;
    //   return {
    //     ...productDetail,
    //   };
    case "OPEN_ADD_PRODUCT_MODAL":
      return {
        ...productDetail,
        product_modal: payload,
      };
    case "CLOSE_ADD_PRODUCT_MODAL":
      return {
        ...productDetail,
        product_modal: payload,
        edit: false,
        _id: "",
        name: "",
        price: "",
        discount: "",
        points: "",
        description: "",
        type: "",
        category: "",
        pieces: "",
        reservation: "",
        sold: "",
      };
    case "SET_MESSAGE":
      const { canvasMessage, message: successMessage } = payload;
      return {
        ...productDetail,
        message: successMessage,
        loadingMessage: canvasMessage,
      };
    case "SET_CANVAS":
      const { openCanvas, message } = payload;
      return {
        ...productDetail,
        canvas: openCanvas,
        loadingMessage: message,
      };
    default:
      return productDetail;
  }
};
